// extracted by mini-css-extract-plugin
export var accent = "HeaderMenuDropdown-module--accent--bd631";
export var additionalPartGroup = "HeaderMenuDropdown-module--additionalPartGroup--b4ccb";
export var additionalPartLinks = "HeaderMenuDropdown-module--additionalPartLinks--37bdb";
export var badges = "HeaderMenuDropdown-module--badges--58380";
export var dropdownLink = "HeaderMenuDropdown-module--dropdownLink--c6f6c";
export var itemWithIcon = "HeaderMenuDropdown-module--itemWithIcon--5c801";
export var mainPartTiles = "HeaderMenuDropdown-module--mainPartTiles--e90a6";
export var mainTiles = "HeaderMenuDropdown-module--mainTiles--56773";
export var menuItemHeadline = "HeaderMenuDropdown-module--menuItemHeadline--95240";
export var menuItemsGroup = "HeaderMenuDropdown-module--menuItemsGroup--8a09b";
export var menuSingleItem = "HeaderMenuDropdown-module--menuSingleItem--8daa8";
export var releaseImage = "HeaderMenuDropdown-module--releaseImage--68eaf";
export var root = "HeaderMenuDropdown-module--root--e0459";